module.exports = __webpack_public_path__ + "img/icons BFr_8.49ce7aad.svg";